








































import Vue from "@/shim-vue";
import { Component, Prop, Emit } from "vue-property-decorator";

import type Cell from "../cell";

import config from "@/config/cell-item";

@Component({
    name: "LoniCellItem"
})
export default class LoniCellItem extends Vue {
    /** 是否显示右边icon，默认false */
    @Prop({ type: Boolean, default: undefined })
    public nextIcon?: boolean;

    /** 在点击时触发路由跳转，并且会默认显示nextIcon */
    @Prop()
    public next?: string;

    /** 列表图标 */
    @Prop({ default: "" })
    public icon!: string;

    /** 列表图标颜色 */
    @Prop()
    public iconColor?: string;

    /** 列表标题 */
    @Prop({ default: "" })
    public title!: string;

    /** 固定列表标题宽度 */
    @Prop()
    public titleFixed?: string;

    /** 列表标题文字颜色 */
    @Prop()
    public color?: string;

    /** 列表文本内容文字颜色 */
    @Prop()
    public textColor?: string;

    /** 列表文本内容区域是否使用flex布局 */
    @Prop({ type: Boolean, default: undefined })
    public textFlex?: boolean;

    /** 是否在底部增加20px的margin间距 */
    @Prop({ type: Boolean, default: undefined })
    public spacing?: boolean;

    /** 是否在底部增加20px的间距（填充方式，true默认色值#eee） */
    @Prop({ type: [Boolean, String], default: undefined })
    public spacingFill?: boolean | string;

    /** 是否显示分割线 */
    @Prop({ type: Boolean, default: undefined })
    public splitLine?: boolean;

    /** 列表自定义背景 */
    @Prop()
    public background?: string;

    /** 值居左显示 */
    @Prop({ type: Boolean, default: undefined })
    public textLeft?: boolean;

    // 不用$parent获取父级cell实例是因为上一级不一定是cell，可能是swipeout等
    public cellInstance = {} as Cell;

    public get options() {
        return {
            nextIcon: this.nextIcon ?? config.nextIcon,
            titleFixed: this.titleFixed ?? this.cellInstance?.titleFixed ?? config.titleFixed,
            color: this.color ?? config.color,
            textColor: this.textColor ?? config.textColor,
            iconColor: this.iconColor ?? config.iconColor,
            splitLine: this.splitLine ?? config.splitLine,
            background: this.background ?? config.background,
            textLeft: this.textLeft ?? config.textLeft,
            spacing: this.spacing ?? config.spacing,
            spacingFill: this.spacingFill ?? config.spacingFill,
            textFlex: this.textFlex ?? config.textFlex
        }
    }

    private get spacingFillColor() {
        if(typeof this.options.spacingFill === "string") {
            return this.options.spacingFill;
        }
        return "#eee";
    }

    @Emit("click")
    private active() {
        if(this.next) {
            this.$router.push(this.next);
        }
    }
}
